// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__23z8L","log":"ModalInventoryLogs_log__HMcvu","date":"ModalInventoryLogs_date__16nPn","userName":"ModalInventoryLogs_userName__bLWZ2"};